import { ContainerModule } from 'inversify';
import 'reflect-metadata';

import { ApiGateway } from './api-gateway';
import { TYPES as ApiGatewayTypes, IApiGateway } from './api-gateway.types';

const container = new ContainerModule((bind) => {
  bind<IApiGateway>(ApiGatewayTypes.ApiGateway).to(ApiGateway).inSingletonScope();
});

export { container };
